import type { TModule } from '@modules/core/types';

import { CARDS_ROUTE_PATHS } from './config';
import { DEBIT_CARD_OPERATIONS_ROUTES } from './debit-card-operations';
import { AFFILIATES_ROUTES } from './affiliates';
import { DEBIT_CARD_ABM_ROUTES } from './debit-card-abm';
import { PRODUCT_PACK_ROUTES } from './debit-card-product-pack';

const cardsModule: TModule = {
  id: 'cards',
  fallbackRoute: [CARDS_ROUTE_PATHS.debitCardOperations],
  permissions: { roles: [] },
  isPublic: false,
  routes: [...DEBIT_CARD_OPERATIONS_ROUTES, ...AFFILIATES_ROUTES, ...DEBIT_CARD_ABM_ROUTES, ...PRODUCT_PACK_ROUTES],
};

export { CARDS_ROUTE_PATHS as CardsRoutePaths };

export default cardsModule;
